import { create } from 'zustand';
import api from '../lib/api';

const useCrmStore = create((set, get) => ({
  leads: [],
  totalLeads: 0,
  stages: [],
  lossReasons: [],
  metrics: null,
  agents: [],
  loading: false,

  fetchStages: async () => {
    const { data } = await api.get('/pipeline/stages');
    set({ stages: data });
  },

  fetchLossReasons: async () => {
    const { data } = await api.get('/pipeline/loss-reasons');
    set({ lossReasons: data });
  },

  fetchLeads: async (params = {}) => {
    set({ loading: true });
    const { data } = await api.get('/leads', { params });
    set({ leads: data.leads, totalLeads: data.total, loading: false });
    return data;
  },

  fetchMetrics: async () => {
    const { data } = await api.get('/dashboard/metrics');
    set({ metrics: data });
  },

  fetchAgents: async () => {
    const { data } = await api.get('/agentes');
    set({ agents: data });
  },

  createLead: async (leadData) => {
    const { data } = await api.post('/leads', leadData);
    const currentLeads = get().leads;
    set({ leads: [data, ...currentLeads] });
    return data;
  },

  updateLead: async (leadId, updates) => {
    const { data } = await api.put(`/leads/${leadId}`, updates);
    const updated = get().leads.map(l => l.id === leadId ? data : l);
    set({ leads: updated });
    return data;
  },

  moveLead: async (leadId, stage, motivo_inactivo, notas_inactivo) => {
    const body = { stage };
    if (motivo_inactivo) body.motivo_inactivo = motivo_inactivo;
    if (notas_inactivo) body.notas_inactivo = notas_inactivo;
    const { data } = await api.put(`/leads/${leadId}/move`, body);
    const updated = get().leads.map(l => l.id === leadId ? data : l);
    set({ leads: updated });
    return data;
  },

  fetchObservaciones: async (leadId) => {
    const { data } = await api.get(`/leads/${leadId}/observaciones`);
    return data;
  },

  createObservacion: async (leadId, texto) => {
    const { data } = await api.post(`/leads/${leadId}/observaciones`, { texto });
    return data;
  },

  createActividad: async (actData) => {
    const { data } = await api.post('/actividades', actData);
    return data;
  },
}));

export default useCrmStore;
